import type { IOnboardingState } from 'interfaces/store/features-state';

import { OnboardingActionNames, type OnboardingAction } from './actions';

const initialState: IOnboardingState = {
  selectedOnboardingStep: null,
  displayedSteps: [],
  isChecklistOpen: undefined,
};

export default function onboardingReducer(
  state: IOnboardingState = initialState,
  action: OnboardingAction,
): IOnboardingState {
  switch (action.type) {
    case OnboardingActionNames.SET_SELECTED_STEP:
      return {
        ...state,
        selectedOnboardingStep: action.payload,
      };
    case OnboardingActionNames.ADD_DISPLAYED_STEP:
      if (state.displayedSteps.includes(action.payload)) {
        return state;
      }

      return {
        ...state,
        displayedSteps: [...state.displayedSteps, action.payload],
      };
    case OnboardingActionNames.SET_CHECKLIST_OPEN:
      return {
        ...state,
        isChecklistOpen: action.payload,
      };
    default:
      return state;
  }
}
